type BackgroundSet = 'all' | 'home';

const BACKGROUNDS: Record<BackgroundSet, { desktop: string; mobile: string }> = {
  all: {
    desktop: '/background_all.webp',
    mobile: '/background_all_mobile.webp',
  },
  home: {
    desktop: '/Halloween-hero.webp',
    mobile: '/Halloween-hero-tablet.webp',
  },
};

interface RandomBackgroundProps {
  className?: string;
  backgroundSet?: BackgroundSet;
}

export default function RandomBackground({
  className = '',
  backgroundSet = 'all',
}: Readonly<RandomBackgroundProps>) {
  const selectedBackground = BACKGROUNDS[backgroundSet];

  return (
    <picture className={`pointer-events-none fixed inset-0 -z-20 block ${className}`}>
      <source media="(min-width: 1024px)" srcSet={selectedBackground.desktop} />
      <img
        src={selectedBackground.mobile}
        alt=""
        aria-hidden
        fetchPriority="high"
        loading="eager"
        decoding="async"
        className="h-full w-full object-cover object-top md:object-[center_-5.5rem] lg:object-center"
      />
    </picture>
  );
}
